import Modal from 'react-modal'
import { popup_padding } from 'src/config/config'

import { ModalCloseButton } from '../global/ModalCloseButton'

interface Props {
  isOpen: boolean
  onClose: () => void
  callback: () => void
}

const ModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    backgroundColor: 'transparent',
    border: '0px solid red',
  },
}

export const UpgradeToEnhancedModal: React.FC<Props> = ({ isOpen, onClose, callback }) => {
  const handleClose = () => {
    onClose()
  }

  const onSubmit = () => {
    callback()
    handleClose()
  }

  return (
    <Modal closeTimeoutMS={200} isOpen={isOpen} onRequestClose={handleClose} style={ModalStyles} ariaHideApp={false}>
      <div className="flex">
        <div className="flex flex-col md:w-[620px] w-full">
          <div className="flex flex-row w-full" style={{ zIndex: '10' }}>
            <ModalCloseButton onClose={handleClose} className="md:top-[4px] top-[6px] md:right-[3px] right-[-12px]" />
          </div>
          <div className="flex flex-col overflow-hidden mr-[15px] mt-[-20px]">
            <div className={`request-contact-container flex flex-row w-full ${popup_padding} md:w-[600px]`}>
              <div className="flex flex-col w-full">
                <div className="flex items-center">
                  <p className="flex items-center h-[81px] text-[24px] font-bold font-secondary text-darkgray">
                    Upgrade To Enhanced
                  </p>
                </div>

                <p className="flex items-center h-[40px] text-[18px] font-bold font-secondary text-darkgray mt-2">
                  Are you sure you want to submit this request?
                </p>

                <div className="flex flex-row w-full pt-6 items-center md:gap-[16px] gap-[8px]">
                  <button
                    className="px-7 h-[50px] rounded-full bg-[#011d58] grow-2 w-[100px] font-semibold text-[14px]"
                    type="submit"
                    onClick={onSubmit}
                  >
                    <p className="text-white">Submit</p>
                  </button>

                  <button
                    className="px-7 h-[50px] rounded-full bg-white grow-2 w-[100px] border border-solid border-inherit font-semibold text-[14px]"
                    onClick={handleClose}
                  >
                    <p className="text-[#333333]">Cancel</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
